<template>
  <div v-loading="loading">
    <el-card>
      <el-button icon="el-icon-arrow-left" @click="changeDateBy(-1)">
        上一日
      </el-button>
      <el-date-picker
        v-model="date"
        :placeholder="$t('chart.date.start')"
        :picker-options="datePickerOptions"
        type="datetime"
        format="yyyy/MM/dd HH:mm"
        @change="changeDate"
      />
      <el-button icon="el-icon-arrow-right" :disabled="isNextDayDisabled" @click="changeDateBy(1)">
        下一日
      </el-button>
      <el-button v-if="showOutputTable" @click="uploadCheck">
        上傳資料
      </el-button>
      <el-button v-if="isSelectInstrumentType && isContinuityType && !roading" @click="insGroupUpload">
        上傳資料
      </el-button>
      <span v-if="showOutputTable" style="margin-left:12px;">
        重新計算變化量
        <el-switch v-model="autoCalcReading2" />
      </span>
      <!--el-select v-model="instrumentType" placeholder="請選擇儀器類型" @change="changeInstrumentType">
        <el-option
          v-for="item in instrumentTypeList"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select-->
      <el-cascader
        v-model="instrumentType"
        :options="instrumentType_options"
        :props="{ expandTrigger: 'hover' }"
        :placeholder="$t('manual.selectInstrumentType')"
        @change="changeInstrumentType"
      >
      </el-cascader>
      <el-cascader
        v-if="!kmrtRole"
        :key="instrumentCascaderKey"
        v-model="selectedInstrumentList"
        style="min-width:200px"
        :options="instrumentOptions"
        :props="props"
        :disabled="isContinuityType"
        :collapse-tags="true"
        :show-all-levels="false"
        :placeholder="$t('chart.instrument.pick')"
        @change="getCascaderInstrumentList"
      ></el-cascader>
      <el-select
        v-if="kmrtRole && !isContinuityType"
        v-model="area"
        placeholder="請選擇區域"
        @change="changeArea"
      >
        <el-option
          v-for="item in areaList"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
    </el-card>
    <el-card v-if="showOutputTable">
      <hot-table id="hot-container" ref="hot" root="hot" :settings="settings" />
    </el-card>
    <instrument-group-edit
      v-if="isSelectInstrumentType && isContinuityType && !loading"
      :key="instrumentGroupEditKey"
      :outputList="outputList"
      :getInstrumentType="getInstrumentType"
      :date="date"
      :earlyDateIds="earlyDateIds"
      ref="insGroupEdit"
    >
    </instrument-group-edit>
  </div>
</template>

<script>
import moment from 'moment';
import MomentTimeZone from 'moment-timezone';
import { HotTable } from '@handsontable/vue';
import InstrumentGroupEdit from '@/components/manual/InstrumentGroupEdit.vue';
import { EDIT_PASS_TABLE } from '@/constants/userRoles.js';
import { InstrumentTypeCascaderOption, TemplateDownloadLinkSelectOption } from '@/constants/instrumentTemplateDLOption';
import { clientVersion } from '@/constants/env';
import {
  createInstrumentCascadeProps,
  createLazyLoadInstrumentOptions,
  expandSelectedCascadeToInstruments,
  getCascadeAreas,
  getCascadeStations,
  getCascadeInstruments,
  getSelectedInstrumentValues,
} from '@/lib/base/instrumentCascade';
import manualProjectMixin from '@/lib/base/manualProject';

MomentTimeZone();
export default {
  mixins: [manualProjectMixin],
  components: {
    HotTable,
    InstrumentGroupEdit,
  },
  computed: {
    selectedProject() {
      return this.$store.getters['project/selectedProject'];
    },
    settings() {
      const vm = this;
      return {
        data: vm.outputList,
        fixedColumnsLeft: 1,
        colHeaders: vm.columnsHeader,
        rowHeaders: true,
        manualRowResize: true,
        manualColumnResize: true,
        manualRowMove: true,
        customBorders: true,
        columnSorting: true,
        height: 600,
        width: '100%',
        columns: vm.columns,
        licenseKey: 'non-commercial-and-evaluation',

        beforeChange(changes, source) {
          // [[row, prop, oldVal, newVal], ...]
          vm.hasUnsavedChanges = true;
          for(let change of changes){
            let row = vm.$refs.hot.hotInstance.toPhysicalRow(change[0]);
            const key = change[1];
            const raw = change[3];
            const numericKeys = ['reading', 'A+', 'A-', 'Gate1', 'Gate2', 'Gate3'];

            vm.outputList[row][key] =
              numericKeys.includes(key)
                ? (raw === '' || raw === null || raw === undefined ? '' : Number(raw))
                : raw;
            if(change[1] === 'reading') {
              let instrument = vm.instrumentMap?.get(vm.outputList[row].instrumentName);
              if(!isNaN(Number(change[3]))) {
                const computed = vm.computedOutput(vm.outputList[row], instrument);
                vm.outputList[row].result = computed.result;
                vm.outputList[row].status = computed.status;
                vm.outputList[row].remark = computed.remark;
              } else {
                vm.outputList[row].result = '';
              }
            }
            if(change[1] === 'A+') {
              if(!isNaN(Number(change[3])) && !isNaN(Number(vm.outputList[row]['A-']))) {
                let instrument = vm.instrumentMap?.get(vm.outputList[row].instrumentName);
                const computed = vm.computedOutput(vm.outputList[row], instrument);
                vm.outputList[row].result = computed.result;
                vm.outputList[row].status = computed.status;
                vm.outputList[row].remark = computed.remark;
              } else {
                vm.outputList[row].result = '';
              }
            }
            if(change[1] === 'A-') {
              if(!isNaN(Number(change[3])) && !isNaN(Number(vm.outputList[row]['A+']))) {
                let instrument = vm.instrumentMap?.get(vm.outputList[row].instrumentName);
                const computed = vm.computedOutput(vm.outputList[row], instrument);
                vm.outputList[row].result = computed.result;
                vm.outputList[row].status = computed.status;
                vm.outputList[row].remark = computed.remark;
              } else {
                vm.outputList[row].result = '';
              }
            }

            if (vm.isLCType() && ['Gate1', 'Gate2', 'Gate3'].includes(key)) {
              const rowObj = vm.outputList[row];
              const allReady = ['Gate1', 'Gate2', 'Gate3'].every(k => rowObj[k] !== '' && !isNaN(Number(rowObj[k])));
              const instrument = vm.instrumentMap?.get(rowObj.instrumentName);

              if (allReady && instrument) {
                const computed = vm.computedOutput(rowObj, instrument);
                rowObj.result = computed.result;
                rowObj.status = computed.status;
                rowObj.remark = computed.remark;
              } else {
                rowObj.result = '';
              }
            }
          }
        },

        cells(row, col) {
          if (!vm.columns[col]) return {};
          const cp = {};
          const colKey = vm.columns[col].data;
          const rowData = vm.outputList[row];

          if (vm.EDITABLE_OUTPUT_COLS.includes(colKey)) {
            if (vm.isOutputRowLocked(rowData)) {
              cp.readOnly = true;
            } else if (vm.editPass && vm.isPastEditWindow(rowData)) {
              // admin/edit 檢視：此欄位對 client 角色而言已超過 1 日可編輯窗口
              cp.className = 'client-locked-cell';
              cp.clientLocked = true;
            }
          }

          if (colKey === 'remark') {
            let remarkClass = '';
            const cellVal = this.instance.getDataAtCell(row, col);
            if (cellVal === '超過行動值') remarkClass = 'WSL-remark';
            else if (cellVal === '超過警戒值') remarkClass = 'AL-remark';
            else if (cellVal === '超過注意值') remarkClass = 'WL-remark';
            if (remarkClass) {
              cp.className = cp.className ? `${cp.className} ${remarkClass}` : remarkClass;
            }
          }

          return cp;
        },
        afterRenderer(TD, row, col, prop, value, cellProperties) {
          if (cellProperties.clientLocked) {
            TD.title = '此欄位已超過 client 角色可編輯的 1 日窗口，僅 admin/edit 角色可編輯';
          }
        },
      };
    },
    datePickerOptions(){
      const vm = this;
      return {
        disabledDate(date) {
          return date > new Date();
        },
        cellClassName(date) {
          return vm.existingDates.has(moment(date).format('YYYY-MM-DD')) ? 'manual-data-exist' : '';
        },
      };
    },
    isSelectInstrumentType(){
      return this.getInstrumentType;
    },
    kmrtRole(){
      return clientVersion === 'kmrt';
    },
    // kmrt 版本需要儀器類型 + 區域都選定後才顯示儀器清單
    showOutputTable(){
      return this.isSelectInstrumentType && !this.isContinuityType && (!this.kmrtRole || !!this.area);
    },
    isNextDayDisabled(){
      return moment(this.date).startOf('day').isSameOrAfter(moment().startOf('day'));
    },
    isAverageInstrumentType(){
      return this.instrumentType.includes('VG');
    },
    isContinuityType() {
      const instrumentTypeName = this.instrumentType?.[1];
      if(!instrumentTypeName) return false;
      return instrumentTypeName.includes('SIS') || instrumentTypeName.includes('SID') || instrumentTypeName.includes('ISS (傾斜)');
    },
    getInstrumentType(){
      const instrumentType = this.instrumentType?.[1];
      return this.instrumentTypeList.find(ele=>{
        return ele.name === instrumentType;
      });
    },
    useLazyInstrumentLoad(){
      return !!this.manualProject?.config?.use_lazy_instrument_load && !this.isContinuityType;
    },
    props(){
      return createInstrumentCascadeProps({
        lazy: this.useLazyInstrumentLoad,
        lazyLoad: this.lazyLoadInstrumentOptions,
      });
    },
    instrumentCascaderKey(){
      const type = Array.isArray(this.instrumentType) ? this.instrumentType.join('-') : this.instrumentType;
      // non-lazy: 不含 type，切換儀器類型時不重建 cascader，保留選取狀態
      return this.useLazyInstrumentLoad ? `lazy-${type || 'all'}` : 'normal';
    },
    instrumentGroupEditKey(){
      return `${this.getInstrumentType?._id || 'none'}-${this.date ? moment(this.date).valueOf() : 'no-date'}-${this.outputList.length}`;
    },
    columns() {
      let constCol = this.constCol;
      let insTypeObjKey = Object.keys(this.getInstrumentType);
      if( insTypeObjKey.includes('A+') && insTypeObjKey.includes('A-') && this.getInstrumentType['A+'] && this.getInstrumentType['A-'] )
      {
        constCol = this.constCol.filter(ele=>{
          return ele!='reading' && ele!='R0';
        });
      }
      // === LC：顯示 Gate 初值/讀值；隱藏 R0 / reading ===
      if (this.isLCType()) {
        constCol = constCol
          .filter(ele => !['R0', 'reading'].includes(ele))
          .concat([
            'Gate1initial', 'Gate2initial', 'Gate3initial',
            'Gate1', 'Gate2', 'Gate3',
          ]);
      }
      return  this.col.filter(ele => {
        let insTypeObjKey = Object.keys(this.getInstrumentType);
        return (insTypeObjKey.includes(ele.data) && this.getInstrumentType[ele.data]) || constCol.includes(ele.data);
      });
    },
    columnsHeader() {
      let constCol = this.constCol;
      let insTypeObjKey = Object.keys(this.getInstrumentType);
      if( insTypeObjKey.includes('A+') && insTypeObjKey.includes('A-') && this.getInstrumentType['A+'] && this.getInstrumentType['A-'] )
      {
        constCol = this.constCol.filter(ele=>{
          return ele!='reading' && ele!='R0';
        });
      }
      // === LC：顯示 Gate 初值/讀值；隱藏 R0 / reading ===
      if (this.isLCType()) {
        constCol = constCol
          .filter(ele => !['R0', 'reading'].includes(ele))
          .concat([
            'Gate1initial', 'Gate2initial', 'Gate3initial',
            'Gate1', 'Gate2', 'Gate3',
          ]);
      }
      let col = this.col.map((ele, index)=>{
        return {
          data: ele.data,
          index,
        };
      }).filter(ele => {
        let insTypeObjKey = Object.keys(this.getInstrumentType);
        return (insTypeObjKey.includes(ele.data) && this.getInstrumentType[ele.data]) || constCol.includes(ele.data);
      });
      return this.colHeader.filter((ele, index)=>{
        return col.findIndex(c=> c.index == index) >= 0;
      });
    },
    userRole() {
      return this.$store.getters['user/details'].roles;
    },
    editPass() {
      return !!EDIT_PASS_TABLE[this.userRole];
    },
    instrumentType_options() {
      return InstrumentTypeCascaderOption.map(ele=>{
        return {
          value: ele.value,
          label: ele.label,
          children: ele.children.map(child=>{
            const instrumentType = this.instrumentTypeList.find(instrumentType=>{
              return child.value === instrumentType.name;
            });
            return {
              value: child.value,
              label: child.label,
              disabled: !instrumentType,
            };
          }),
        };
      });
    },
  },
  data(){
    return {
      EDITABLE_OUTPUT_COLS: ['reading', 'Gate1', 'Gate2', 'Gate3', 'A+', 'A-', 'remark'],
      constCol: [
        'instrumentName',
        'unit',
        'R0',
        'F1',
        'reading',
        'result',
        'lastOutput',
        'diff',
        'WL',
        'AL',
        'WSL',
        'remark',
      ],
      col: [
        {
          data: 'instrumentName',
          readOnly: true,
        },
        {
          data: 'unit',
          readOnly: true,
        },
        {
          data: 'R0',
          readOnly: true,
        },
        // === LC: Gate 初值（readonly）===
        {
          data: 'Gate1initial',
          readOnly: true,
        },
        {
          data: 'Gate2initial',
          readOnly: true,
        },
        {
          data: 'Gate3initial',
          readOnly: true,
        },
        
        {
          data: 'A+initial',
          readOnly: true,
        },
        {
          data: 'A-initial',
          readOnly: true,
        },
        {
          data: 'F1',
          readOnly: true,
        },
        {
          data: 'reading',
        },

        // === LC: Gate 讀值（editable）===
        {
          data: 'Gate1',
        },
        {
          data: 'Gate2',
        },
        {
          data: 'Gate3',
        },

        {
          data: 'A+',
        },
        {
          data: 'A-',
        },
        {
          data: 'result',
          readOnly: true,
        },
        {
          data: 'lastOutput',
          readOnly: true,
        },
        {
          data: 'diff',
          readOnly: true,
        },
        {
          data: 'WL',
          readOnly: true,
        },
        {
          data: 'AL',
          readOnly: true,
        },
        {
          data: 'WSL',
          readOnly: true,
        },
        {
          data: 'remark',
          editor: 'select',
          selectOptions: ['', '阻礙', '損壞', '無法進入', '不合格', '暫停量測', '不明原因', '碰撞', '重新安裝', '停止量測'],
        },
      ],
      colHeader: [
        '儀器名稱',
        '單位',
        '初值',
        'Gate1 初值',
        'Gate2 初值',
        'Gate3 初值',
        '正向初值',
        '負向初值',
        'F1',
        '讀值',
        'Gate1 讀值',
        'Gate2 讀值',
        'Gate3 讀值',
        'A+',
        'A-',
        '變化量',
        '前次變化量',
        '差值',
        '注意值',
        '警戒值',
        '行動值',
        '備註',
      ],
      outputList: [],
      earlyDateIds: [],
      originInstrumentList: [],
      commonTypeInstrumentList: [],
      isFullInstrumentListLoaded: false,
      instrumentList: [],
      date: moment().startOf('day'),
      existingDates: new Set(),
      instrumentTypeList: [],
      instrumentType: '',

      instrumentOptions: [],
      selectedInstrumentList: [],
      loadedInstrumentAreas: [],
      area: '',
      areaList: [],
      loading: false,
      instrumentLoading: false,
      typeLoading: false,
      outputLoading: false,

      hasUnsavedChanges: false,
      autoCalcReading2: false,
      rawApiOutput: [],
      rawApiOutputMap: new Map(),
      instrumentMap: new Map(),
    };
  },
  watch: {
    instrumentLoading() {
      this.loading = this.instrumentLoading || this.typeLoading || this.outputLoading;
    },
    typeLoading() {
      this.loading = this.instrumentLoading || this.typeLoading || this.outputLoading;
    },
    outputLoading() {
      this.loading = this.instrumentLoading || this.typeLoading || this.outputLoading;
    },
    autoCalcReading2() {
      this.applyOutputList();
    },
  },
  beforeRouteLeave(to, from, next) {
    if (this.hasUnsavedChanges) {
      // 瀏覽器內建的 confirm，也可以換成自己實作的 Modal
      const answer = window.confirm('您有未儲存的變更，確定要離開嗎？');
      if (answer) {
        next();       // 繼續離開
      } else {
        next(false);  // 中止導航，留在原來頁面
      }
    } else {
      next();  // 沒修改，直接離開
    }
  },
  async mounted(){
    this.getInstrumentTypeList();
    await this.getInstruments();
    if (this.kmrtRole) this.getAreaList();
    //await this.getOutput();
  },
  methods: {
    async getInstrumentTypeList(){
      this.typeLoading = true;
      const res = await this.$axios({
        category: 'manual',
        method: 'get',
        apiName: 'instrument_type',
      });
      this.instrumentTypeList = res.data.filter(ele => ele.manual).map(ele=>{
        return {
          ...ele,
          value: ele.name,
          label: ele.name,
        };
      }).sort((a,b) => a.value[0].localeCompare(b.value[0]));
      this.typeLoading = false;
    },
    async getInstruments(){
      this.instrumentLoading = true;
      if (this.useLazyInstrumentLoad) {
        this.instrumentOptions = [];
        this.originInstrumentList = [];
        this.commonTypeInstrumentList = [];
        this.isFullInstrumentListLoaded = false;
        this.instrumentLoading = false;
        return;
      }

      const res = await this.$axios({
        category: 'manual',
        method: 'get',
        apiName: `getManualInstrument/${this.manualProjectId}`,
      });
      this.originInstrumentList = res.data;
      this.isFullInstrumentListLoaded = true;
      this.getInstrumentsData();
      this.initCascaderSelector();
      this.instrumentLoading = false;
    },
    getCascadeAreas(){
      return getCascadeAreas({
        axios: this.$axios,
        projectId: this.manualProjectId,
      });
    },
    getCascadeStations(area){
      return getCascadeStations({
        axios: this.$axios,
        projectId: this.manualProjectId,
        area,
      });
    },
    getCascadeInstruments(area, station){
      return getCascadeInstruments({
        axios: this.$axios,
        projectId: this.manualProjectId,
        area,
        station,
        instrumentType: this.getInstrumentType,
        valueKey: 'name',
      });
    },
    async getFullManualInstruments(){
      const res = await this.$axios({
        category: 'manual',
        method: 'get',
        apiName: `getManualInstrument/${this.manualProjectId}`,
      });
      this.originInstrumentList = res.data;
      this.loadedInstrumentAreas = [];
      this.isFullInstrumentListLoaded = true;
      this.initCascaderSelector();
    },
    async getManualInstrumentByType(){
      const res = await this.$axios({
        category: 'manual',
        method: 'get',
        apiName: `getManualInstrumentByType/${this.manualProjectId}/${this.getInstrumentType._id}`,
      });
      this.originInstrumentList = res.data;
      this.commonTypeInstrumentList = res.data;
      this.loadedInstrumentAreas = [];
      this.isFullInstrumentListLoaded = false;
    },
    async lazyLoadInstrumentOptions(node, resolve){
      return createLazyLoadInstrumentOptions({
        getAreas: this.getCascadeAreas,
        getStations: this.getCascadeStations,
        getInstruments: this.getCascadeInstruments,
      })(node, resolve);
    },
    async expandSelectedCascadeToInstruments(){
      if(!this.useLazyInstrumentLoad || this.selectedInstrumentList.length === 0) return;
      this.selectedInstrumentList = await expandSelectedCascadeToInstruments({
        selectedList: this.selectedInstrumentList,
        getStations: this.getCascadeStations,
        getInstruments: this.getCascadeInstruments,
      });
    },
    // kmrt 專用：區域下拉選單（取代原本的區域-測站-儀器聯集選擇器）
    async getAreaList(){
      this.areaList = await this.getCascadeAreas();
    },
    applyAreaSelection(){
      if (this.useLazyInstrumentLoad) {
        // lazy 模式：交給既有的 expandSelectedCascadeToInstruments 去後端展開該區域全部儀器
        this.selectedInstrumentList = this.area ? [[this.area]] : [];
        return;
      }
      this.selectedInstrumentList = this.area
        ? this.commonTypeInstrumentList
          .filter(ins => ins.area === this.area)
          .map(ins => [ins.area, ins.station, ins.data[0].name])
        : [];
    },
    async changeArea(){
      this.applyAreaSelection();
      await this.getCascaderInstrumentList();
    },
    getInstrumentsData(){
      if (this.kmrtRole && !this.isContinuityType && !this.area) {
        // kmrt：儀器類型 + 區域都選定前，不列出任何儀器
        this.outputList = [];
        this.earlyDateIds = [];
        this.instrumentList = [];
        this.instrumentMap = new Map();
        this.updateTable();
        return;
      }
      this.outputList = [];
      this.earlyDateIds = [];
      const earlyDateNames = [];
      const selectedInstrumentNames = this.getSelectedInstrumentNames();
      let instrumentList = this.commonTypeInstrumentList.filter(ins => {
        if(selectedInstrumentNames.length == 0) return true;
        return selectedInstrumentNames.includes(ins.data[0].name);
      }).map(ins => {
        let index = this.getDataByTime(ins, this.date);
        if (index === -1) {
          earlyDateNames.push(ins.data[0].name);
          this.earlyDateIds.push(String(ins._id));
        }
        let data = ins.data[index];

        let WL_plus = ![null,NaN,undefined].includes(data ? data.WL_plus : undefined);
        let WL_minus = ![null,NaN,undefined].includes(data ? data.WL_minus : undefined);
        let AL_plus = ![null,NaN,undefined].includes(data ? data.AL_plus : undefined);
        let AL_minus = ![null,NaN,undefined].includes(data ? data.AL_minus : undefined);
        let WSL_plus = ![null,NaN,undefined].includes(data ? data.WSL_plus : undefined);
        let WSL_minus = ![null,NaN,undefined].includes(data ? data.WSL_minus : undefined);

        let WL = '';
        if(WL_plus && WL_minus) WL = `${data.WL_plus}/${data.WL_minus}`;
        else if(WL_plus) WL = `${data.WL_plus}`;
        else if(WL_minus) WL = `${data.WL_minus}`;
        let AL = '';
        if(AL_plus && AL_minus) AL = `${data.AL_plus}/${data.AL_minus}`;
        else if(AL_plus) AL = `${data.AL_plus}`;
        else if(AL_minus) AL = `${data.AL_minus}`;
        let WSL = '';
        if(WSL_plus && WSL_minus) WSL = `${data.WSL_plus}/${data.WSL_minus}`;
        else if(WSL_plus) WSL = `${data.WSL_plus}`;
        else if(WSL_minus) WSL = `${data.WSL_minus}`;
        return {
          _id: ins._id,
          name: ins.data[0].name,
          unit: ins.data[0].unit,
          area: ins.area,
          station: ins.station,
          status: ins.status,
          R0: data ? data.R0 : '',
          'A+initial': data ? data['A+'] : '',
          'A-initial': data ? data['A-'] : '',
          offset: data ? data.offset : '',
          T0: data ? data.T0 : '',
          K : data ? data.K : '',
          F0: data ? data.F0 : '',
          F1: data ? data.F1 : '',
          F2: data ? data.F2 : '',
          F3: data ? data.F3 : '',
          F4: data ? data.F4 : '',
          F5: data ? data.F5 : '',

          Gate1initial: data ? (data?.other_value?.gage1_initial ?? '') : '',
          Gate2initial: data ? (data?.other_value?.gage2_initial ?? '') : '',
          Gate3initial: data ? (data?.other_value?.gage3_initial ?? '') : '',

          WL,
          AL,
          WSL,
          decimal_points: data ? data.decimal_points : 2,
          startDate: data ? data.startDate : '',
        };
      }).filter(ins => {
        return ins.R0 !== '';
      });

      if (earlyDateNames.length > 0 && !this.isContinuityType) {
        this.$message.warning(`以下儀器的初值時間晚於所選時間，無法顯示：${earlyDateNames.join('、')}`);
      }

      instrumentList = instrumentList.sort((a, b) =>
        a.name.localeCompare(b.name, undefined, { numeric: true, sensitivity: 'base' }),
      );
      
      for(let instrument of instrumentList){
        this.outputList.push({
          instrumentName: instrument.name,
          R0: instrument.R0,
        });
      }
      this.instrumentList = instrumentList;
      this.instrumentMap = new Map(instrumentList.map(ins => [ins.name, ins]));
    },
    getDataByTime(instrument, time){
      let index = -1;
      let datas = instrument.data.sort((a, b)=>{
        return a.startDate - b.startDate;
      });
      for(let data of datas){
        index++;
        if(moment(data.startDate) > time) {
          index--;
          break;
        }
      }
      return index;
    },
    initCascaderSelector() {
      this.instrumentOptions = [];
      this.selectedInstrumentList = [];

      let areas = {};

      this.originInstrumentList.forEach(ins=>{
        if(areas[ins.area]){
          areas[ins.area].push(ins);
        }
        else areas[ins.area] = [ins];
      });

      let instrumentOptions = [];

      for(let key of Object.keys(areas)){
        areas[key] = areas[key].reduce((acc,cur)=>{
          let index = acc.stations.findIndex(ele => ele.station === cur.station);
          if(index < 0){
            acc.stations.push({
              station: cur.station,
              instruments: [cur],
            });
          }
          else{
            acc.stations[index].instruments.push(cur);
          }
          return acc;
        },{ stations: []});

        instrumentOptions.push({
          label: key,
          value: key,
          //disabled: areas[key].stations.length === 0,
          children: areas[key].stations.map((station)=>{
            return {
              label: station.station,
              value: station.station,
              //disabled: station.instruments.length === 0,
              children: station.instruments.map(ins=>{
                return {
                  label: ins.data[0].name,
                  value: ins.data[0].name,
                  leaf: true,
                };
              }),
            };
          }),
        });
      }

      this.instrumentOptions = instrumentOptions;
    },
    async getOutput(){
      this.outputLoading = true;

      if (this.isContinuityType || (this.kmrtRole && !this.area)) {
        this.rawApiOutput = [];
      } else {
        const res = await this.$axios({
          category: 'manual',
          method: 'get',
          apiName: `getAllManualInstrumentOutput/${this.manualProjectId}`,
          params: {
            date: this.date,
            instrument_type: this.getInstrumentType?._id,
          },
        });
        this.rawApiOutput = res.data;
      }

      this.rawApiOutputMap = new Map(this.rawApiOutput.map(o => [o.name, o]));
      this.applyOutputList();
      this.outputLoading = false;
      this.updateTable();
    },
    applyOutputList(){
      this.outputList = this.outputList.map(ele => {
        const output = this.rawApiOutputMap.get(ele.instrumentName);
        const instrument = this.instrumentMap.get(ele.instrumentName);
        if (!instrument) return ele;
        const prevRemark = output?.remark || '';
        const prevStatus = instrument.status;

        if (!output || [NaN, null, undefined].includes(output.reading2)) {
          return {
            ...ele,
            ...instrument,
            lastOutput: output?.lastOutput,
            remark: prevRemark,
            prevRemark,
            prevStatus,
            created_at: output?.created_at,
          };
        }

        if (this.autoCalcReading2) {
          // 用輸入的 reading / A+ / A- 重新計算
          const tempRow = {
            ...ele,
            ...instrument,
            reading: output.reading,
            'A+': output['A+'],
            'A-': output['A-'],
            lastOutput: output.lastOutput,
            remark: output.remark ?? prevRemark,
            readings: output.readings,
            ...output.readings,
          };
          const computed = this.computedOutput(tempRow, instrument);
          return {
            ...tempRow,
            result: computed.result,
            diff: computed.diff,
            status: computed.status,
            remark: computed.remark,
            prevRemark,
            prevStatus,
            created_at: output.created_at,
          };
        }

        // 後端已有資料，直接顯示，不重新計算
        return {
          ...ele,
          ...instrument,
          reading: output.reading,
          'A+': output['A+'],
          'A-': output['A-'],
          result: output.reading2,
          diff: (![undefined, NaN, null].includes(output.lastOutput) && ![undefined, NaN, null].includes(output.reading2))
            ? Number(output.reading2 - output.lastOutput).toFixed(4) : '',
          status: output.status,
          remark: output.remark ?? prevRemark,
          lastOutput: output.lastOutput,
          prevRemark,
          prevStatus,
          readings: output.readings,
          ...output.readings,
          created_at: output.created_at,
        };
      });
      this.updateTable();
    },
    computedOutput(output, instrument){

      if (this.isLCType()) {
        return this.computedLCOutput(output, instrument); 
      }

      let reading1 = output.reading ? output.reading : 0;
      let A_plus = output['A+'] ? output['A+'] : 0;
      let A_minus = output['A-'] ? output['A-'] : 0;
      let A_plusInitial = instrument['A+initial'] ? instrument['A+initial'] : 0;
      let A_minusInitial = instrument['A-initial'] ? instrument['A-initial'] : 0;
      //  (F5(R1)^5＋F4(R1)^4＋F3(R1)^3＋F2(R1)^2+F1(R1)+F0 ) - (F5(R0)^5＋F4(R0)^4＋F3(R0)^3＋F2(R0)^2+F1(R0)+F0 )+offset
      let front =
        instrument.F5 * Math.pow(reading1, 5) +
        instrument.F4 * Math.pow(reading1, 4) +
        instrument.F3 * Math.pow(reading1, 3) +
        instrument.F2 * Math.pow(reading1, 2) +
        instrument.F1 * reading1 +
        instrument.F0 +
        instrument.F1 * A_plus -
        instrument.F1 * A_minus ;
      let rear =
        instrument.F5 * Math.pow(instrument.R0, 5) +
        instrument.F4 * Math.pow(instrument.R0, 4) +
        instrument.F3 * Math.pow(instrument.R0, 3) +
        instrument.F2 * Math.pow(instrument.R0, 2) +
        instrument.F1 * instrument.R0 +
        instrument.F0 +
        instrument.F1 * A_plusInitial -
        instrument.F1 * A_minusInitial ;
      let reading2 = (front - rear + instrument.offset).toFixed(instrument.decimal_points || 2);
      let alertStatus = this.getStatusAfterOutput(reading2, instrument, output.remark);
      return {
        reading: reading1,
        'A+': A_plus,
        'A-': A_minus,
        result : reading2,
        diff: (![undefined, NaN, null].includes(output.lastOutput) && ![undefined, NaN, null].includes(reading2)) ? Number(reading2 - output.lastOutput).toFixed(4) : '',
        status: alertStatus.status,
        remark: alertStatus.remark,
        readings: output.readings,
        ...output.readings,
      };
    },

    computedLCOutput(output, instrument){
      // === LC：支撐荷重計 ===
      const toNum = v => (v === '' || v === null || v === undefined) ? NaN : Number(v);

      const g1 = toNum(output?.readings?.Gate1 ?? output?.Gate1);
      const g2 = toNum(output?.readings?.Gate2 ?? output?.Gate2);
      const g3 = toNum(output?.readings?.Gate3 ?? output?.Gate3);

      const g1i = toNum(instrument.Gate1initial) || 0;
      const g2i = toNum(instrument.Gate2initial) || 0;
      const g3i = toNum(instrument.Gate3initial) || 0;

      // Gate1~3 沒填完整就不算，避免用 0 造成誤判
      if ([g1, g2, g3].some(v => Number.isNaN(v))) {
        return { result: '', diff: '', status: instrument.status ?? 'green', remark: output.remark ?? '' };
      }

      const avgDelta = ((g1 - g1i) + (g2 - g2i) + (g3 - g3i)) / 3;
      const reading2Num = avgDelta * (Number(instrument.F1) || 0);
      const reading2 = reading2Num.toFixed(instrument.decimal_points || 2);

      const alertStatus = this.getStatusAfterOutput(reading2, instrument, output.remark);

      return {
        Gate1: g1,
        Gate2: g2,
        Gate3: g3,
        readings: output.readings,
        result: reading2,
        diff: (![undefined, NaN, null].includes(output.lastOutput) && ![undefined, NaN, null].includes(reading2))
          ? Number(reading2 - output.lastOutput).toFixed(4)
          : '',
        status: alertStatus.status,
        remark: alertStatus.remark,
      };
    },

    async uploadCheck(){
      let outputList = this.buildUploadOutputList();
      if (!outputList) return;

      const result = await this.$axios({
        category: 'manual',
        method: 'post',
        apiName: 'uploadOutputChecking',
        data: {
          outputs: outputList,
          date: this.date,
          project: this.manualProjectId,
        },
      });

      console.log(result);

      if(!(result?.data) || result?.data?.error) {
        console.error(result?.data?.error);
        this.$message.error('發生錯誤');
        return;
      }

      const exist_instruments = result?.data?.exist_instruments;
      console.log(exist_instruments);
      if(exist_instruments.length==0){
        // pass
        return this.uploadOutput();
      }
      let ins_str = '';
      for(let instrument_name of exist_instruments){
        ins_str += '\n' + instrument_name;
      }

      if(this.editPass){
        try {
          await this.$confirm(
            `確認到重覆上傳，共有${exist_instruments.length}資料重複，\n請確認是否覆蓋，${ins_str}`,
            '資料重複',
            { 
              type: 'warning', 
              confirmButtonText: '確認',
              cancelButtonText: '取消', 
            },
          );
        } catch {
          this.$message.info('已取消上傳');
          return; // 使用者取消
        }

        return this.uploadOutput();
      }

      this.$alert(`確認到重覆上傳，共有${exist_instruments.length}資料重複，\n請檢察，${ins_str}`,
        '資料重複', 
        {
          confirmButtonText: '確定',
        },
      );
    },

    async uploadOutput(){
      let outputList = this.buildUploadOutputList();
      if (!outputList) return;
      // === 新增：上傳前的狀態升級檢查 ===
      const upgraded = [];
      for (const row of outputList) {
        if (this.isStatusUpgrade(row.status, row.prevStatus)) {
          upgraded.push({
            instrumentName: row.instrumentName,
            from: row.prevRemark || 'green',
            to: row.remark || 'green',
          });
        }
        const hasAnyGate = ['Gate1','Gate2','Gate3'].some(k => row[k] !== '' && row[k] !== null && row[k] !== undefined);
        if(hasAnyGate){
          row.readings = {
            Gate1: row.Gate1,
            Gate2: row.Gate2,
            Gate3: row.Gate3,
          };
        }
      }

      if (upgraded.length > 0) {
        try {
          await this.$confirm(
            '將發送告警，確定上傳？',
            '狀態升級確認',
            { type: 'warning', confirmButtonText: '確定', cancelButtonText: '取消' },
          );
        } catch {
          this.$message.info('已取消上傳');
          return; // 使用者取消
        }
      }

      this.outputLoading = true;
      this.$axios({
        category: 'manual',
        method: 'put',
        apiName: 'addManualOutput',
        data: {
          outputs: outputList,
          date: this.date,
          project: this.manualProjectId,
        },
      }).then(()=>{
        this.$notifySuccess('新增成功');
        this.outputLoading = false;
        this.hasUnsavedChanges = false;
        this.updateTable();
        this.getExistingDates();
      });
    },
    insGroupUpload(){
      this.$refs.insGroupEdit.uploadOutput();
    },
    changeDate(){
      if(!this.getInstrumentType) return;
      this.getInstrumentsData();
      this.getOutput();
    },
    changeDateBy(days){
      this.date = moment(this.date).add(days, 'days').toDate();
      this.changeDate();
    },
    async changeInstrumentType(){
      //console.log(this.getInstrumentType);
      if(!this.getInstrumentType) return;

      this.instrumentLoading = true;
      try {
        this.instrumentOptions = [];
        if (this.useLazyInstrumentLoad) {
          this.selectedInstrumentList = [];
          await this.getManualInstrumentByType();
        }
        else if (!this.isFullInstrumentListLoaded) {
          await this.getFullManualInstruments();
        }
        else {
          // non-lazy: 保留選取狀態，不清空
          const savedSelection = this.selectedInstrumentList.slice();
          this.initCascaderSelector();
          this.selectedInstrumentList = savedSelection;
          this.refreshCommonTypeInstrumentList();
        }
        if (this.kmrtRole && this.area && !this.isContinuityType) {
          // kmrt：用新儀器類型 + 既有已選區域，重新算 selectedInstrumentList 並刷新
          await this.changeArea();
          await this.getExistingDates();
        } else {
          this.getInstrumentsData();
          await Promise.all([this.getOutput(), this.getExistingDates()]);
        }
      } finally {
        this.instrumentLoading = false;
      }
    },
    async getExistingDates(){
      if(!this.getInstrumentType) {
        this.existingDates = new Set();
        return;
      }
      const res = await this.$axios({
        category: 'manual',
        method: 'get',
        apiName: `getManualOutputTimeList/${this.manualProjectId}`,
        params: {
          instrument_type: this.getInstrumentType._id,
        },
      });
      this.existingDates = new Set(
        (res.data || [])
          .filter(Boolean)
          .map(timestamp => moment(timestamp).format('YYYY-MM-DD')),
      );
    },
    async getCascaderInstrumentList(){
      //console.log(this.selectedInstrumentList);
      if(this.isContinuityType) return;

      if(this.useLazyInstrumentLoad) {
        this.instrumentLoading = true;
        try {
          await this.expandSelectedCascadeToInstruments();
        } finally {
          this.instrumentLoading = false;
        }
      }
      this.getInstrumentsData();
      this.getOutput();
    },
    getSelectedInstrumentNames(){
      return getSelectedInstrumentValues(this.selectedInstrumentList);
    },
    refreshCommonTypeInstrumentList(){
      this.commonTypeInstrumentList = this.originInstrumentList.filter(ele=> {
        //console.log(ele.instrument_type);
        return ele.instrument_type._id == this.getInstrumentType?._id;
      });
    },
    updateTable() {
      console.log(this.outputList);
      if(this.showOutputTable)
        setTimeout(() => {
          this.$refs.hot?.hotInstance?.loadData(this.outputList);
        }, 100);
    },

    getStatusAfterOutput(value, instrument, lastRemark){
      //console.log(instrument);
      //![NaN,null,undefined].includes(result) && (result>)

      if(lastRemark && !['超過行動值','超過警戒值','超過注意值'].includes(lastRemark)) return {
        status: instrument.status,
        remark: lastRemark,
      };

      const { WSL = '', AL = '', WL = '' } = instrument;
      const splitRange = str =>
        str ? str.split('/').map(Number) : [null, null];

      const [WSL_plus, WSL_minus] = splitRange(WSL);
      const [AL_plus , AL_minus ] = splitRange(AL);
      const [WL_plus , WL_minus ] = splitRange(WL);

      let checkList = [WSL_plus, WSL_minus, WL_plus, WL_minus, AL_plus, AL_minus];

      const toNumber = v =>
        v === null || v === '' || /^\s*$/.test(v)
          ? NaN
          : Number(v);

      value = toNumber(value);

      //console.log(checkList);
      //console.log(value, typeof value);

      let instrument_name = instrument.name;
      if (checkList.some(ele => ele !== null)){
        if (this.checkValue(value, WSL_minus, WSL_plus)) {
          return {
            remark: '超過行動值',
            status: 'WSL',
          };
        } else if (this.checkValue(value, AL_minus, AL_plus)) {
          return {
            remark: '超過警戒值',
            status: 'AL',
          };
        } else if (this.checkValue(value, WL_minus, WL_plus)) {
          return {
            remark: '超過注意值',
            status: 'WL',
          };
        } else {
          console.log(instrument_name, 'isnt over than any alert value.');
        }
      }
      return {
        remark: '',
        status: 'green',
      };
    },
    checkValue(x, min, max) {
      if (typeof x !== 'number' || isNaN(x)) {
        return false;
      }
      if ((!min && min != 0) && (!max && max != 0)) {
        return false;
      } else {
        if ((min || min == 0) && (max || max == 0)) {
          return !this.$lodash.inRange(x, min, max);
        } else if (min || min == 0) {
          return x <= min;
        } else if (max || max == 0) {
          return x >= max;
        } else {
          return false;
        }
      }
    },

    isStatusUpgrade(status, instrument_status){
      return this.statusToNumber(status) > this.statusToNumber(instrument_status);
    },

    statusToNumber(status){
      const STATUS_NUMBER_TABLE = {
        'green': 0,
        'WL': 1,
        'AL': 2,
        'WSL': 3,
        'down': 4,
      };
      return STATUS_NUMBER_TABLE[status] ?? 0;
    },

    isLCType() {
      const instrumentTypeName = this.instrumentType?.[1];
      if (!instrumentTypeName) return false;
      return instrumentTypeName.includes('LC');
    },

    // 該筆輸出資料是否已超過建立後 24 小時的可編輯窗口（與角色無關，純時間判斷）
    isPastEditWindow(row) {
      if (!row?.created_at) return false;
      const elapsedSeconds = (Date.now() - new Date(row.created_at).getTime()) / 1000;
      return elapsedSeconds > 60 * 60 * 24;
    },
    // 非 admin/edit 角色，既有輸出資料超過建立後 24 小時即鎖定不可編輯
    isOutputRowLocked(row) {
      if (this.editPass) return false;
      return this.isPastEditWindow(row);
    },

    buildUploadOutputList() {
      // undefined / null / '' 均視為「無值」，方便比較
      const norm = v => (v === undefined || v === null || v === '') ? null : v;

      // 先沿用你原本的過濾方式
      let outputList = this.outputList.filter(output => {
        const isnull = Object.keys(output).length === 0 ||
          Object.values(output).reduce((acc, v) => acc && [''].includes(v), true);
        return !isnull;
      });

      // LC：必須 Gate1~3 都有值；有填但不完整就直接擋下
      if (this.isLCType()) {
        const gateKeys = ['Gate1', 'Gate2', 'Gate3'];
        const invalid = [];
        const filtered = [];
        const beforeCount = outputList.length;

        for (const row of outputList) {
          // 與原始 API 資料比較，Gate1~3 及備註皆未變化 → 視為未調整，跳過
          const original = this.rawApiOutputMap.get(row.instrumentName);
          const hasChange =
            norm(row.Gate1) !== norm(original?.readings?.Gate1) ||
            norm(row.Gate2) !== norm(original?.readings?.Gate2) ||
            norm(row.Gate3) !== norm(original?.readings?.Gate3) ||
            norm(row.remark) !== norm(original?.remark);
          if (!hasChange) continue;

          const allReady = gateKeys.every(k => row[k] !== '' && row[k] !== null && row[k] !== undefined && !isNaN(Number(row[k])));
          if (!allReady) {
            invalid.push(row.instrumentName);
            continue;
          }

          const instrument = this.instrumentMap.get(row.instrumentName);
          const computed = this.computedOutput(row, instrument);

          row.result = computed.result;
          row.status = computed.status;
          row.remark = computed.remark;

          // 保險：若後端吃 reading2，就一併送
          row.reading2 = computed.result;

          filtered.push(row);
        }

        const noDataCount = beforeCount - filtered.length - invalid.length;
        console.log(`儀器過濾：過濾前 ${beforeCount} 個，過濾後 ${filtered.length} 個，過濾掉 ${noDataCount} 個未調整數據的儀器`);

        if (invalid.length) {
          this.$message.error(`LC 有未填完整 Gate1~3 的儀器：${invalid.join(', ')}`);
          return null;
        }

        outputList = filtered;
      } else {
        // 非 LC：與原始 API 資料比較，判斷是否有調整
        const insType = this.getInstrumentType;
        const isAPlusMinusType = insType &&
          Object.keys(insType).includes('A+') && insType['A+'] &&
          Object.keys(insType).includes('A-') && insType['A-'];

        const beforeCount = outputList.length;

        outputList = outputList.filter(row => {
          const original = this.rawApiOutputMap.get(row.instrumentName);
          const remarkChanged = norm(row.remark) !== norm(original?.remark);
          if (isAPlusMinusType) {
            return norm(row['A+']) !== norm(original?.['A+']) ||
                   norm(row['A-']) !== norm(original?.['A-']) ||
                   remarkChanged;
          } else {
            return norm(row.reading) !== norm(original?.reading) || remarkChanged;
          }
        });

        const afterCount = outputList.length;
        console.log(`儀器過濾：過濾前 ${beforeCount} 個，過濾後 ${afterCount} 個，過濾掉 ${beforeCount - afterCount} 個未調整數據的儀器`);
      }

      if (outputList.length === 0) {
        this.$message.error('所有儀器均未調整數據，無法上傳');
        return null;
      }

      return outputList;
    },
  },
};
</script>
  
<style>
.WSL-remark {
  color: #FF0000 !important;
  font-weight: 700 !important;/* 粗體 */
}
.AL-remark {
  color: #FFAD00 !important;  
  font-weight: 700 !important;/* 粗體 */
}
.WL-remark {
  color: #4188FF !important;
  font-weight: 700 !important;/* 粗體 */
}
.client-locked-cell {
  background-color: #FDF6EC !important;
}
.el-date-table td.manual-data-exist span {
  position: relative;
}
.el-date-table td.manual-data-exist span::after {
  content: '';
  position: absolute;
  bottom: 2px;
  left: 50%;
  transform: translateX(-50%);
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background-color: #67C23A;
}
</style>
